const Pagination = ({ currentPage, totalPages, onPageChange }) => {
	const handlePageChange = (page) => {
		if (page >= 1 && page <= totalPages) {
			onPageChange(page);
		}
	};

	const renderPageNumbers = () => {
		const pages = [];

		if (totalPages <= 3) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(
					<li key={i}>
						<button
							onClick={() => handlePageChange(i)}
							className={`flex h-8 min-w-[32px] items-center justify-center border px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
								currentPage === i
									? "cursor-not-allowed border-gray-700 bg-blue-gray text-white"
									: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:bg-opacity-60 hover:text-white"
							}`}
						>
							{i}
						</button>
					</li>,
				);
			}
		} else {
			pages.push(
				<li key={1}>
					<button
						onClick={() => handlePageChange(1)}
						className={`flex h-8 min-w-[32px] items-center justify-center border px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
							currentPage === 1
								? "cursor-not-allowed border-gray-700 bg-blue-gray text-white"
								: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:bg-opacity-60 hover:text-white"
						}`}
					>
						1
					</button>
				</li>,
			);

			if (currentPage > 4) {
				pages.push(
					<li key="ellipsis-start">
						<span className="flex h-8 items-center justify-center border border-gray-700 bg-dark-blue px-2 text-gray-400 text-xs leading-tight sm:px-3 sm:text-sm">
							...
						</span>
					</li>,
				);
			}

			const startPage = Math.max(currentPage - 1, 2);
			const endPage = Math.min(currentPage + 1, totalPages - 1);

			for (let i = startPage; i <= endPage; i++) {
				pages.push(
					<li key={i}>
						<button
							onClick={() => handlePageChange(i)}
							className={`flex h-8 min-w-[32px] items-center justify-center border px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
								currentPage === i
									? "cursor-not-allowed border-gray-700 bg-blue-gray text-white"
									: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:bg-opacity-60 hover:text-white"
							}`}
						>
							{i}
						</button>
					</li>,
				);
			}

			if (currentPage < totalPages - 3) {
				pages.push(
					<li key="ellipsis-end">
						<span className="flex h-8 items-center justify-center border border-gray-700 bg-dark-blue px-2 text-gray-400 text-xs leading-tight sm:px-3 sm:text-sm">
							...
						</span>
					</li>,
				);
			}

			if (totalPages > 1) {
				pages.push(
					<li key={totalPages}>
						<button
							onClick={() => handlePageChange(totalPages)}
							className={`flex h-8 min-w-[32px] items-center justify-center border px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
								currentPage === totalPages
									? "cursor-not-allowed border-gray-700 bg-blue-gray text-white"
									: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:bg-opacity-60 hover:text-white"
							}`}
						>
							{totalPages}
						</button>
					</li>,
				);
			}
		}

		return pages;
	};

	return (
		<nav aria-label="Page navigation">
			<ul className="flex items-center justify-center text-xs sm:justify-start sm:text-sm">
				<li>
					<button
						onClick={() => handlePageChange(currentPage - 1)}
						disabled={currentPage === 1}
						className={`flex h-8 min-w-[60px] items-center justify-center rounded-s-lg border border-e-0 px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
							currentPage === 1
								? "cursor-not-allowed border-gray-700 bg-dark-blue text-gray-500"
								: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:bg-opacity-60 hover:text-white"
						}`}
					>
						Previous
					</button>
				</li>
				{renderPageNumbers()}
				<li>
					<button
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={currentPage === totalPages}
						className={`flex h-8 min-w-[60px] items-center justify-center rounded-e-lg border px-2 text-xs leading-tight sm:px-3 sm:text-sm ${
							currentPage === totalPages
								? "cursor-not-allowed border-gray-700 bg-dark-blue text-gray-500"
								: "border-gray-700 bg-dark-blue text-blue-gray hover:bg-blue-gray hover:text-white"
						}`}
					>
						Next
					</button>
				</li>
			</ul>
		</nav>
	);
};

export default Pagination;
